const Promise = require('es6-promise');
const Logger = require('./utils/logger');
const Request = require('./request');
const assign = require('./utils/assign');

function formatSessionUrl(endpoint, sessionUrl) {
  return endpoint.replace('{url}', sessionUrl);
}

/**
 * Creates an instance of TokenManager.
 *
 * @constructor
 * @param {Storage} storage Initiated storage
 * @param {Object} [options] Options for initating Token Manager
 * @param {String} [options.storageKey='spotii:auth:registration'] Key for storing token data in local storage.
 */
function RegistrationManager(storage, options) {
  const defaultOptions = {
    storageKey: 'spotii:auth:registration',
  };
  this.options = assign(defaultOptions, options);
  this.storage = storage;
  this.log = new Logger('[spotii-auth.registration]');
  this.request = Request.create({
    baseUrl: this.options.baseUrl,
  });

  this.sessionUrl = null;
  this.verificationUrl = null;
}

RegistrationManager.prototype.create = function(
  email,
  password,
  phoneNumber = null,
  fullName = null,
  kwargs = {},
) {
  const self = this;

  return this.request('create', {
    url: self.options.endpoints.create,
    method: 'POST',
    data: {
      user: {
        email: email,
        password: password,
        phoneNumber: phoneNumber,
        fullName: fullName,
        ...kwargs,
      },
    },
  }).then(function(resp) {
    // Keep registration session URL in memory and localStorage
    self.sessionUrl = resp.headers.location;
    self.storage.setItem(self.options.storageKey, self.sessionUrl);
    return resp.data;
  });
};

RegistrationManager.prototype.update = function(data) {
  return this.request('update', {
    url: formatSessionUrl(this.options.endpoints.update, this.sessionUrl),
    method: 'PATCH',
    data: data,
  }).then(function(resp) {
    return resp.data;
  });
};

RegistrationManager.prototype.validate = function() {
  const self = this;
  return this.request('validate', {
    url: formatSessionUrl(this.options.endpoints.validate, this.sessionUrl),
    method: 'PATCH',
  }).then(function(resp) {
    self.verificationUrl = resp.headers.location;
    return resp.data;
  });
};

RegistrationManager.prototype.verify = function(code) {
  const self = this;
  return this.request('verify', {
    url: self.verificationUrl,
    method: 'PATCH',
    data: {
      code: code,
    },
  }).then(function(resp) {
    // User is registered after verification.
    self.storage.removeItem(self.options.storageKey);
    return resp.data;
  });
};

RegistrationManager.prototype.restore = function() {
  const sessionUrl = this.storage.getItem(this.options.storageKey);

  if (sessionUrl) {
    return this.request('restore', {
      url: sessionUrl,
      method: 'GET',
    }).then(function(resp) {
      return resp.data;
    });
  }

  return Promise.reject();
};

module.exports = RegistrationManager;
